import React, { useContext, useState } from "react";
import { observer } from "mobx-react-lite";
import { groupBy as rowGrouper } from "lodash";
import DataGrid from "react-data-grid";
import { Row, Col, Button } from "react-bootstrap";

import StoryContext from "../store/context";
import { format_time, format_date } from "../utils/formatDate";
import { er, exportToXlsx } from "../utils/exportUtils";

import CheckboxTree from "react-checkbox-tree";

const outlets = [
  {
    name: "Торгівельна точка",
    key: "outlet",
  },
  {
    name: "Клієнт",
    key: "client",
  },
  {
    name: "Кількість",
    key: "amount",
  },
];

function rowKeyGetter(row) {
  // console.log(JSON.stringify(row))
  return row.uuid;
}

const Report = observer(() => {
  const store = useContext(StoryContext);
  const [date, setDate] = useState(format_date(Date.now()));
  const [checked, setChecked] = useState(["mars", "phobos"]);
  const [expanded, setExpanded] = useState(["mars", "phobos"]);

  // console.log(store.reportAmountOutlets.slice());

  const nodes = [
    {
      value: "mars",
      label: "Mars",
      children: [
        { value: "phobos", label: "Phobos" },
        { value: "deimos", label: "Deimos" },
      ],
    },
  ];

  return (
    <>
      <Row>
        <Col>
          <input
            name="requested_order_ship_date"
            value={date}
            type="date"
            className="form-control"
            onChange={(event) => setDate(event.target.value)}
          />
        </Col>
        <Col>
          <Button onClick={() => store.getPeriodOutlets(date)}>
            Сформувати
          </Button>{" "}
        </Col>
      </Row>
      <CheckboxTree
        nodes={nodes}
        checked={checked}
        expanded={expanded}
        onCheck={(checked) => console.log(checked)}
        onExpand={(expanded) => console.log(expanded)}
      />
      <DataGrid
        style={{ height: 600, marginTop: 5 }}
        columns={outlets}
        rows={store.reportAmountOutlets.slice()}
        rowKeyGetter={rowKeyGetter}
      />
    </>
  );
});

export default Report;
